module.exports = __webpack_public_path__ + "img/bus_purple_1.24e4efac.svg";